import { EquipmentTransferStatus } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { EQUIPMENT_TRANSFER_STATUS_LABEL_MAP } from 'noddi-util';
import { EQUIPMENT_TRANSFER_STATUS_ICON } from './EquipmentStatusIcon';

const VARIANT_BY_STATUS = {
  [EquipmentTransferStatus.PENDING]: 'warning',
  [EquipmentTransferStatus.COMPLETED]: 'success',
  [EquipmentTransferStatus.REJECTED]: 'destructive',
  [EquipmentTransferStatus.CANCELLED]: 'outline'
} as const;

export const EquipmentTransferStatusBadge = ({ status }: { status: EquipmentTransferStatus }) => (
  <NoddiBadge variant={VARIANT_BY_STATUS[status]}>
    <NoddiIcon name={EQUIPMENT_TRANSFER_STATUS_ICON[status]} size='small' />
    {EQUIPMENT_TRANSFER_STATUS_LABEL_MAP[status]}
  </NoddiBadge>
);
